<template>
  <div class="max-w-4xl py-5 mx-auto md:px-5">
    <PageHeader title="Add Automation" :subtitle="automationTypes[form.type].name" :back-route="{ name: 'AutomationList' }">
      <label class="flex items-center form-label">
        <toggle :value.sync="form.enabled" class="mr-4" /> 
        Enable This Automation
      </label>
    </PageHeader>

    <div>
      <form @submit.prevent="createAutomation()" class="pb-6 space-y-6">
        <automation-form :form="form" :methods="methods" />
        <div class="flex justify-between px-1 py-6">
          <button type="submit" class="btn btn-primary" v-submitting="submitting">Create Automation</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import AutomationForm from './AutomationForm'

  export default {
    name: 'AutomationCreate',

    metaInfo: {
      title: 'New Automation'
    },

    components: {
      AutomationForm
    },

    computed: {
      ...mapState(['automationTypes'])
    },

    data () {
      return {
        submitting: false,
        form: {
          name: '',
          type: this.$route.params.type,
          emails: [],
          cellphones: [],
          vehicles: [],
          areas: [],
          schedules:[],
          area_policy: '',
          threshold: 0,
          condition: 0,
          notify_driver: false,
          driver_message: '',
          activate_output: false,
          deactivate_output: false,
          send_webfleet_notification: false,
          trigger_dashboard_alert: false,
          require_acknowledgement: false,
          enabled: false
        },
        methods: {
          toggleArea: this.toggleArea,
          toggleSchedule: this.toggleSchedule,
          toggleContact: this.toggleContact,
          toggleVehicle: this.toggleVehicle,
          toggleAllVehiclesOn: this.toggleAllVehiclesOn,
          toggleAllVehiclesOff: this.toggleAllVehiclesOff
        }
      }
    },

    methods: {
      async createAutomation () {
        try {
          this.submitting = true
          await this.$api.post(`account/${this.$route.params.account}/automations`, this.form)
          this.$store.dispatch('syncUser', this)
          this.$router.push({ name: 'AutomationList' })
          this.$toasted.show('Automation added.')
        } catch (error) {
          console.error(error)
        } finally {
          this.submitting = false
        }
      },

      toggleVehicle (vehicle) {
        let index = this.form.vehicles.findIndex(v => v.id === vehicle.id)

        if (index > -1) {
          this.$delete(this.form.vehicles, index)
        } else {
          this.$set(this.form.vehicles, this.form.vehicles.length, vehicle)
        }
      },

      toggleAllVehiclesOn (vehicles) {
        this.form.vehicles = JSON.parse(JSON.stringify(vehicles))
      },

      toggleAllVehiclesOff () {
        this.form.vehicles = []
      },

      toggleContact (type, id) {
        let contactType = type + 's'
        if (this.form[contactType].indexOf(id) > -1) {
          let index = this.form[contactType].indexOf(id)
          this.$delete(this.form[contactType], index)
        } else {
          this.$set(this.form[contactType], this.form[contactType].length, id)
        }
      },

      toggleSchedule (schedule) {
        let index = this.form.schedules.findIndex(s => s.id === schedule.id)

        if (index > -1) {
          this.$delete(this.form.schedules, index)
        } else {
          this.$set(this.form.schedules, this.form.schedules.length, schedule)
        }
      },

      toggleArea (area) {
        let index = this.form.areas.findIndex(a => a.id === area.id)

        if (index > -1) {
          this.$delete(this.form.areas, index)
        } else {
          this.$set(this.form.areas, this.form.areas.length, area)
        }
      }
    }
  }
</script>